import { IFilter } from "../interfaces/IFilter";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const create = async (data: { name: string }) => {
  return httpRequest.post("/erp/back_office/item_reference/package_type", data);
};

export const select = async () => {
  return httpRequest.get("/erp/back_office/item_reference/package_type/select");
};

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/erp/back_office/item_reference/package_type", { offset, filter });
};

export const remove = async (id: string) => {
  return httpRequest.del(`/erp/back_office/item_reference/package_type/${id}`);
};

export const update = async (id: string, data: { name: string }) => {
  return httpRequest.put(`/erp/back_office/item_reference/package_type/${id}`, data);
};
